import { action, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import formatAuthenticationProvider from '../services/formatters/authenticationProviderFormatter';
import agent from '../services/web/agent';
import authenticationProvidersStore from './authenticationProvidersStore';

class TeamMembersStore {

    @setter @observable teamUsers;
    @observable putTeamUsersErrorMessage;
    @observable addingUserToTeam;
    @observable removeTeamUserErrorMessage;
    @observable removingUserFromTeam;
    @observable teamUserIds = {
        userIds: []
    };

    @action getTeamUsers(teamId) {

        return agent.TeamMembers.getTeamUsers(teamId)
            .then(action((users) => {

                authenticationProvidersStore.getAllAuthenticationProviders()
                .then((providers) => {
                    
                    for (let i = 0; i < users.length; i++) {
                    
                        users[i] = users[i];
                        users[i].fullName = users[i].firstName + ' ' + users[i].lastName;
                        let provider = providers.filter(p => p.id == users[i].authenticationProviderId)[0];
                        users[i].authenticationProvider = formatAuthenticationProvider(provider);                   
                    }
                    
                    this.teamUsers = users;
                    this.initTeamUserIds();
                });
            }));
    }

    @action putTeamUsers(teamId) {

        this.addingUserToTeam = true;

        return agent.TeamMembers.putTeamUsers(teamId, this.teamUserIds)
            .then(action(() => {

                this.getTeamUsers(teamId);
            }))
            .catch(action((err) => {

                if (err && err.response && err.response.text) {
    
                    this.putTeamUsersErrorMessage = JSON.parse(err.response.text).Message;
                }

                throw err;
            }))
            .finally(action(() => {
                this.addingUserToTeam = false;
            }));
    }

    @action removeTeamUser(teamId, userId) {

        this.removingUserFromTeam = true;

        return agent.TeamMembers.removeTeamUser(teamId, userId)
            .then(action(() => {

                this.getTeamUsers(teamId);
            }))
            .catch(action((err) => {

                if (err && err.response && err.response.text) {
    
                    this.removeTeamUserErrorMessage = JSON.parse(err.response.text).Message;
                }

                throw err;
            }))
            .finally(action(() => {
                this.removingUserFromTeam = false;
            }));
    }

    @action appnedUserId(userId) {

        this.teamUserIds.userIds.push(userId);
    }

    @action removeUserId(userId) {

        const index = this.teamUserIds.userIds.indexOf(userId);

        if (index > -1) {
            this.teamUserIds.userIds.splice(index, 1);
        }
    }

    initTeamUserIds() {

        this.teamUserIds.userIds = [];

        if(this.teamUsers) {

            this.teamUsers.forEach(user => {
            
                this.teamUserIds.userIds.push(user.id);
           });
        }
    }
}

export default new TeamMembersStore();